import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_event/$eventSlug/missoes/$missionId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      href: `/missoes/${params.missionId}`,
      replace: true
    })
  }
})
